import { getRequest, patchRequest } from '@helpers/request'
import { logger } from '@helpers/logger'

export const getSportsDbSportsDataServiceLogs = async (page = 1, limit = 10) => {
  try {
    console.log('Fetching sports DB sports data service logs for page:', page, 'limit:', limit)
    const { response, logComplete } = await getRequest(`sportsDbSportsDataServiceLogs?page=${page}&limit=${limit}`)
    console.log('Received sports DB sports data service logs:', response)
    logComplete()
    return response
  } catch (error) {
    console.error('Error fetching sports DB sports data service logs:', error)
    logger.error('getSportsDbSportsDataServiceLogs', error)
    throw error
  }
}

export const getSportsDbSportsDataServiceLog = async (logId) => {
  try {
    console.log('Fetching sports DB sports data service log for ID:', logId)
    const { response, logComplete } = await getRequest(`sportsDbSportsDataServiceLog?logId=${logId}`)
    console.log('Received sports DB sports data service log:', response)
    logComplete()
    return response
  } catch (error) {
    console.error('Error fetching sports DB sports data service log:', error)
    logger.error('getSportsDbSportsDataServiceLog', error)
    throw error
  }
}

export const getSportsDbSportsDataProcessingStatus = async () => {
  try {
    console.log('Fetching sports DB sports data processing status')
    const { response, logComplete } = await getRequest('sportDbSportsDataProcessing')
    console.log('Received sports DB sports data processing status:', response)
    logComplete()
    return response
  } catch (error) {
    console.error('Error fetching sports DB sports data processing status:', error)
    logger.error('getSportsDbSportsDataProcessingStatus', error)
    throw error
  }
}

export const startSportsDbSportsDataProcessing = async () => {
  try {
    console.log('Starting sports DB sports data processing')
    const { response, logComplete } = await patchRequest('sportDbSportsDataProcessing', {
      action: 'start',
    })
    console.log('Sports DB sports data processing start response:', response)
    logComplete()
    return response
  } catch (error) {
    console.error('Error starting sports DB sports data processing:', error)
    logger.error('startSportsDbSportsDataProcessing', error)
    throw error
  }
}
